export const EStyleType = {
  INFO_0: 0, // #0c86c7
  WARNING_1: 1, // #f58014
  DANGER_2: 2, // #e35653
  SECONDARY_3: 3, // #00a29e
  NEUTRAL_4: 4, // #6c757d
};
